import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError, retryWhen, switchMap, take } from 'rxjs/operators';
import { HandleErrorService } from './handle-error.service';
import { empty } from 'rxjs/Observer';
import { SessionStateService } from './session-state.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiService {
    constructor(
        private httpClient: HttpClient,
        private handleErrorService: HandleErrorService,
        private sessionStateService: SessionStateService) { }

    get<T>(url: string, options?: { params: HttpParams }): Observable<any> {
        return this.httpRequest<T>('get', url, null, options ? options.params : null);
    }

    getRaw(url: string, params: HttpHeaders): Observable<HttpResponse<string>> {
        return this.httpClient.get(url, { observe: 'response', headers: params, responseType: 'text' });
    }

    post<T>(url: string, body: any, options?: { params: HttpParams }): Observable<any> {
        return this.httpRequest<T>('post', url, body, options ? options.params : null);
    }

    put<T>(url: string, body: any, options?: { params: HttpParams }): Observable<any> {
        return this.httpRequest<T>('put', url, body, options ? options.params : null);
    }

    patch<T>(url: string, body: any, options?: { params: HttpParams }): Observable<any> {
        return this.httpRequest<T>('patch', url, body, options ? options.params : null);
    }

    delete<T>(url: string, body?: any, options?: { params: HttpParams }): Observable<any> {
        return this.httpRequest<T>('delete', url, body, options ? options.params : null);
    }

    private httpRequest<T>(method: string, url: string, body?: any, params?: HttpParams): Observable<any> {
        return this.httpClient.request<T>(method, url, { body: body, params: params })
            .pipe(
                catchError(err => {
                    return this.handleErrorService.handleHttpResponseError(err, url);
                }),
            );
    }

   
}



// WEBPACK FOOTER //
// ./src/app/core/services/api.service.ts